export default interface CDNVhostRepositoryInterface {
  getVhosts(): Promise<CDNVhostInterface[]>;

  searchVhost(search: string): Promise<CDNVhostInterface[]>;

  getVhostsBatch(
    offset: number,
    limit: number,
    search?: string
  ): Promise<CDNVhostInterface[]>;

  getVhostsCount(): Promise<number>;

  createVhost(data: CDNVhostCreateInterface): Promise<CDNVhostInterface>;

  deleteVhost(websiteId: number): Promise<void>;

  clearCache(websiteId: number): Promise<void>;

  enableXDN(websiteId: number): Promise<void>;

  disableXDN(websiteId: number): Promise<void>;

  enableCDN(websiteId: number): Promise<void>;

  disableCDN(websiteId: number): Promise<void>;

  syncXDNs(): Promise<void>;

  getXDNFeatures(websiteId: number): Promise<XDNFeaturesInterface>;

  setXDNFeatures(websiteId: number, data: XDNFeaturesInterface): Promise<void>;

  deleteXDNFeatures(websiteId: number): Promise<void>;

  updateServerIps(serverId: string): Promise<void>;
}

export interface XDNFeaturesInterface {
  captcha: boolean;
  captchaLevel: boolean;
  qsIgnore: boolean;
  cacheReferer: string[];
  cacheBypass: boolean;
  uaList: string[];
  countryBan: string[];
  countryAction: 'allow' | 'ban' | '';
  countryHtAccess: boolean;
}

export enum VhostStatus {
  ACTIVE = 0,
  DISABLED = 1,
  TERMINATED = 2,
}

export const CDNVhostStatusStrings = {
  0: 'Active',
  1: 'Disabled',
  2: 'Terminated',
};

export interface CDNVhostInterface {
  id: string;
  domain: string,
  websiteId: number;
  originServerHostname: string;
  ip: string;
  status: VhostStatus;
  hash: string;
  xdnEnabled: boolean;
  cdnEnabled?: boolean;
}

export interface CDNVhostCreateInterface {
  domain: string;
  websiteId: number;
  originServerHostname: string;
  ips: string[];
  xdnEnabled: boolean;
}

